import { ReactNode } from 'react';
import { ReloadOutlined } from '@ant-design/icons';
import { useQueryClient } from '@tanstack/react-query';
import { Button } from 'antd';

import { Popover } from '@app/web-components';

import { productFamilyKeys } from '../data';
import { ProductFamilyHierarchyPanel } from '../panels';

export type ProductFamilyHierarchyPopoverProps = {
  productFamilyId?: number;
  productFamilyName?: string;
  children: ReactNode;
};

export const ProductFamilyHierarchyPopover = ({
  productFamilyId,
  productFamilyName,
  children,
}: ProductFamilyHierarchyPopoverProps) => {
  const queryClient = useQueryClient();

  if (!productFamilyId) {
    return null;
  }

  const handleRefresh = () => {
    queryClient.invalidateQueries({ queryKey: productFamilyKeys.detail(productFamilyId) });
  };

  return (
    <Popover.Popover2Modal
      placement="right"
      title={productFamilyName}
      titleContent={
        <Button type="link" size="small" onClick={handleRefresh} icon={<ReloadOutlined />}>
          Refresh
        </Button>
      }
      width={700}
      popoverWidth={500}
      content={<ProductFamilyHierarchyPanel productFamilyId={productFamilyId} />}
    >
      {children}
    </Popover.Popover2Modal>
  );
};
